import * as React from 'react';

const VALIDATION_CRETIREA = {
	val: '',
	isRequired: true,
	minLength: 2,
	label: '',
};

const handleValidation = (val, validate) => {
	if (!val || val.trim('') === '') {
		if (validate.isRequired) {
			return {
				error: `Please enter ${validate.label}`,
				isFocused: true,
				isValid: false,
			};
		} else {
			return {
				error: ``,
				isFocused: true,
				isValid: true,
			};
		}
	} else if (val.length < validate.minLength) {
		return {
			error: `Please enter valid ${validate.label}`,
			isFocused: true,
			isValid: false,
		};
	} else {
		return {
			error: ``,
			isFocused: true,
			isValid: true,
		};
	}
};

export const useValidation = (validation = VALIDATION_CRETIREA) => {
	const { useState } = React;

	const [val, setVal] = useState(validation.val);
	const [isValid, setIsValid] = useState(true);
	const [error, setError] = useState('');
	const [isFocused, setIsFocused] = useState(false);

	const handleValueChange = event => {
		setVal(event.target.value);
	};

	const handleOnBlur = () => {
		const { error, isFocused, isValid } = handleValidation(val, validation);
		setIsFocused(isFocused);
		setError(error);
		setIsValid(isValid);

		return isValid;
	};

	const handleReset = data => {
		setVal(data);
		setIsValid(true);
		setError('');
		setIsFocused(false);
	};

	return {
		isValid,
		isFocused,
		error,
		val,
		label: validation.label,
		handleValueChange,
		handleOnBlur,
		handleReset,
	};
};
